import setFocusedInboxConfigurationOperation from 'owa-service/lib/operation/setFocusedInboxConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Sets IsFocusedInboxCapable flag on server to indicate enable mailbox for focused inbox
 * @return the SetFocusedInboxConfigurationResponse
 */
export function setIsFocusedInboxCapableService() {
    var request = {
        Header: getJsonRequestHeader(),
        IsFocusedInboxCapable: true,
    };
    return setFocusedInboxConfigurationOperation({
        request: request,
    }).then(function (response) {
        return response;
    });
}
//# sourceMappingURL=setIsFocusedCapableService.js.map